package com.dotdrives.client

/**
 * Accumulates every page from a PostgREST-style `range()`-paginated select. `fetchPage(offset)`
 * must return rows for `[offset, offset + pageSize)`, ordered by a **total** order (a tiebreaker
 * column, e.g. `id`, alongside any business sort) — offset pagination has no guaranteed row
 * order across two separate queries otherwise, and a year/month above `pageSize` rows can
 * duplicate or skip a row across a page boundary. Pulled out as a standalone pure function
 * (no Supabase call inside) so the loop's three termination shapes — an exact multiple of
 * `pageSize`, a short final page, and the empty-result case — are unit-testable directly,
 * rather than only "correct by inspection" the way the loop this replaces was.
 */
suspend fun <T> fetchAllPages(pageSize: Long, fetchPage: suspend (offset: Long) -> List<T>): List<T> {
    val rows = mutableListOf<T>()
    var offset = 0L
    while (true) {
        val page = fetchPage(offset)
        rows += page
        offset += page.size
        if (page.size.toLong() < pageSize) break
    }
    return rows
}
